jQuery(document).ready(function ($) {

  // Responsive Videos
  $('main').responsivevideos();

  // Tabs
  $('main').tabs({
    dropdown: true,
    desktop: 1025,
    animated: true
  });

  // Accordions
  // $('main').accordions();

  // Form Labels
  formLabels();

  // Format Phone Numbers
  $('[itemprop="telephone"]').each(function () {
    var number = $(this).text();
    var formattedNumber = number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    $(this).wrapInner('<a href="tel:' + formattedNumber + '"></a>');
  });

  //View More for Alternative Accordions List

  function gatherAltAccordions() {
    var r = $.Deferred();
    $(':not(.accordion-alt-item) + .accordion-alt-item, * > .accordion-alt-item:first-of-type').each(function () {
      $(this).nextUntil(':not(.accordion-alt-item)').addBack().wrapAll('<div class="accordions-alt-list active" />');
    });
    return r;
  }

  function accordionAltButton() {
    var r = $.Deferred();
    $('.accordions-alt-list .accordion-alt-item .description').each(function () {
      $(this).append('<a class="read-more" tabindex="0">View More <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"/></svg></a>')
    });


    $('.accordion-alt-item .read-more').click(function () {
      var $more = $(this).closest('.accordion-alt-item');
      var $toggletext = $(this).closest('.accordion-alt-item .read-more');

      if ($more.hasClass('expanded')) {
        $more.removeClass('expanded');
        $toggletext.html('View More <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"/></svg>');
      } else {
        $more.addClass('expanded');
        $toggletext.html('View Less <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"/></svg>');
      }
    });

    $('.accordion-alt-item .read-more').on('keypress', function (e) {
      if (e.which === 13) {
        var $more = $(this).closest('.accordion-alt-item');
        var $toggletext = $(this).closest('.accordion-alt-item .read-more');

        if ($more.hasClass('expanded')) {
          $more.removeClass('expanded');
          $toggletext.html('View More <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"/></svg>');
        } else {
          $more.addClass('expanded');
          $toggletext.html('View Less <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"/></svg>');
        }
      }
    });
    return r;
  }

  gatherAltAccordions().done(accordionAltButton());
  //View More for Alternative Accordions List - END

  //If subnavigation has no items, then remove
  if ($('.subnavigation ul li').length <= 1) {
    $('.subnavigation').remove();
  }
  //If subnavigation has no items, then remove - END

  //If breadcrumb has 1 or less items, then remove
  if ($('.breadcrumbs-container ul li').length <= 1) {
    $('.breadcrumbs-container').remove();
  }
  //If breadcrumb has 1 or less items, then remove - END

  //If pager has 1 or less page, then remove
  if ($('.pager .page').length <= 1) {
    $('.page').remove();
  }
  //If pager has 1 or less items, then remove - END


  //Subnav Functionality - START
  $('.subnavigation span.more').on('click', function () {
    $('.subnavigation').toggleClass('active');
  });

  $('.subnavigation span.more').on('keypress', function (e) {
    if (e.which === 13) {
      $('.subnavigation').toggleClass('active');
      $('.subnavigation ul li a:last').on('focusout', function () {
        $('.subnavigation.active').removeClass('active');
      });
    }
  });

  //Toggle Portfolio Filter
  $('.select-box.last-name, .select-box.section').on("click", function (e) {
    $(this).find('.button-group').toggle();
    e.stopPropagation();
    $(document).on("click", function (e) {
      $(".button-group").hide();
    });
  });
  $(".button").on("click", function (e) {
    $('.button').removeClass('active');
    $(this).addClass('active');
    if ($('.button').hasClass('active')) {
      $('.filter h2').html($('.button.active').html());
    }
  });

  $('.select-box.last-name, .select-box.section').on("keypress", function (e) {
    if (e.which == 13) {
      $(this).find('.button-group').toggle();
      $('.button-group div:last-child').on('focusout', function () {
        $('.button-group').hide();
      });
    }
  });

  $('.button').on("keypress", function (e) {
    if (e.which == 13) {
      $('.button').removeClass('active');
      $(this).addClass('active');
      if ($('.button').hasClass('active')) {
        $('.filter h2').html($('.button.active').html());
      }
    }
  });

  //Image lightbox for Filters
  $('.element-item .name').on("click", function (e) {
    $('.image').addClass('reveal');
    $('.close, .background-overlay').show();
    $('.image img').attr('src', $(this).attr('data-src'));
    $('.close, .background-overlay').on("click", function () {
      $('.image.reveal img').removeAttr('src');
      $('.image').removeClass('reveal');
      $(this).hide();
    });
    $(document).on('keydown', function (e) {
      if (e.keyCode === 27) { // ESC
        $('.image.reveal img').removeAttr('src');
        $('.image').removeClass('reveal');
        $('.close, .background-overlay').hide();
      }
    });
  });
  $('.element-item .name').on("keypress", function (e) {
    if (e.which == 13) {
      $('.image').addClass('reveal');
      $('.close, .background-overlay').show();
      $('.image img').attr('src', $(this).attr('data-src'));
      $('.close, .background-overlay').on("click", function () {
        $('.image.reveal img').removeAttr('src');
        $('.image').removeClass('reveal');
        $(this).hide();
      });
      $(document).on('keydown', function (e) {
        if (e.keyCode === 27) { // ESC
          $('.image.reveal img').removeAttr('src');
          $('.image').removeClass('reveal');
          $('.close, .background-overlay').hide();
        }
      });
    }
  });

  //Switch out News Details heading with News Headline
  $(document).ready(function () {
    $(".sp-banner-wrapper h1").html($('.news-detail-headline').html());
    $('.news-detail-headline').remove();
  });

  //Switch out Events Details heading with Events Headline
  // $(document).ready(function () {
  //   $(".sp-banner-wrapper h1").html($('.event-details-title span').html());
  //   $('.event-details-title span').remove();
  //   $('.event-details-title').remove();
  // });
});

// Form Labels
function formLabels() {
  // Forms
  $('input:not([type="radio"]):not([type="checkbox"]), textarea, select').focus(function () {
    $(this).parent('div').addClass('focused');
  });

  $('input:not([type="radio"]):not([type="checkbox"]), textarea, select').blur(function () {
    var inputValue = $(this).val();
    // console.log(inputValue);
    if (inputValue === '') {
      $(this).parent('div').removeClass('focused');
    }
  });
  // File Upload
  $('input[type="file"]').each(function () {
    $(this).next('label').after('<span class="file"></span>');
    $(this).on('change', function () {
      var filePath = $(this).val();
      var splitFilePath = filePath.split('\\');
      var fileName = splitFilePath[splitFilePath.length - 1];
      var file = $(this).closest('div').find('.file');
      if (filePath.length === 0) {
      } else {
        file.text(fileName);
      }
    });
  });

  $('.content-section').each(function () {
    if ($(this).text().trim().length == 0) {
      $(this).hide();
    }
  });

  // //Offset Header if Alerts are present.
  // $(window).on('load', function () {
  //   if ($(window).width() > 1024) {
  //     if ($('.subpage .alerts').length >= 1) {
  //       console.log("Alerts is present.");
  //       setTimeout(function () {
  //         $('.alerts').height(function (index, height) {
  //           $('.header').css("min-height", height + 222);
  //           console.log("Added" + " " + height + "px min-height to banner");
  //         });
  //         $('.alerts .close').click(function () {
  //           $('.header, .nav-level1').removeAttr('style');
  //         });
  //       }, 100);
  //     }
  //   }
  // });
}
// Fires Functions on Partial Postback and Page Load
function pageLoad() {
  formLabels();
}